import { atomWithGlobalState } from '@highlight/ipc/jotai'
import { useAtom, useAtomValue } from 'jotai'
import { useCallback, useMemo } from 'react'

/**
 * Handle onboarding walkthrough state.
 */
const onboardingWalkthroughAtom = atomWithGlobalState<boolean>('assistant.onboardingWalkthrough', false)

export const useIsOnboardingWalkthrough = () => {
  const value = useAtomValue(onboardingWalkthroughAtom)
  return value
}
export const useOnboardingWalkthrough = () => {
  const [isOnboardingWalkthrough, setOnboardingWalkthrough] = useAtom(onboardingWalkthroughAtom)

  const wrappedSetOnboardingWalkthrough = useCallback(
    (value: boolean) => {
      setOnboardingWalkthrough(value)
    },
    [setOnboardingWalkthrough],
  )

  return useMemo(() => {
    return {
      isOnboardingWalkthrough,
      setOnboardingWalkthrough: wrappedSetOnboardingWalkthrough,
    }
  }, [isOnboardingWalkthrough, wrappedSetOnboardingWalkthrough])
}
